import React from "react";
import DateTimePicker from "components/GenericComponent/DateTimePicker";

const SearchForm = ({ dataSearch, onChangeData, onChangeDate, onSearch, handleKeyDown }) => (
  <div className="search-new">
    <div className="input-sm-new input-new-18">
      <label htmlFor="sUser" className="font-color-default font-bold">Người thực hiện</label>
      <input
        id="sUser"
        type="text"
        className="form-control input-sm"
        placeholder="Người thực hiện"
        onChange={onChangeData("sUser")}
        onKeyDown={handleKeyDown}
        value={dataSearch.sUser}
      />
    </div>
    <div className="input-sm-new input-new-18">
      <label htmlFor="sNote" className="font-color-default font-bold">Nội dung</label>
      <input
        id="sNote"
        type="text"
        className="form-control input-sm"
        placeholder="Nội dung"
        onChange={onChangeData("sNote")}
        onKeyDown={handleKeyDown}
        value={dataSearch.sNote}
      />
    </div>
    <div className="input-sm-new input-new-18">
      <label htmlFor="sStartDate" className="font-color-default font-bold">Từ ngày</label>
      <DateTimePicker
        id="sStartDate"
        value={dataSearch.sStartDate}
        onChange={onChangeDate("sStartDate")}
        placeholder="Từ ngày"
        name="sStartDate"
      />
    </div>
    <div className="input-sm-new input-new-18">
      <label htmlFor="sEndDate" className="font-color-default font-bold">Đến ngày</label>
      <DateTimePicker
        id="sEndDate"
        value={dataSearch.sEndDate}
        onChange={onChangeDate("sEndDate")}
        placeholder="Đến ngày"
        name="sEndDate"
      />
    </div>
    <div className="input-sm-new input-new-18 search-main-new">
      <button
        type="submit"
        className="btn btn-info-new"
        style={{ marginTop: "28px", paddingTop: "7px" }}
        onClick={onSearch}
      >
        <i className="la la-search"></i>
        <span> &nbsp; Tìm kiếm</span>
      </button>
    </div>
  </div>
);

export default SearchForm;